export enum PRODUCT_TEMPLATE_PERMISSIONS {
  PRODUCT_TEMPLATE_VIEW = 'PRODUCT_TEMPLATEVIEW',
  PRODUCT_TEMPLATE_WRITE = 'PRODUCT_TEMPLATEWRITE',
}
